module.exports = __webpack_public_path__ + "static/media/404c.47332f98.png";